export const SETTINGS_STORAGE_KEY = 'gsplat-test.spark-settings'
export const MODEL_URL = '/models/e10307d8.sog'
export const NUMERIC_LERP_RATE = 6

export const defaultSettings = {
  effect: {
    enabled: true,
    family: 'Reveal',
    effect: 'Magic',
    intensity: 0.8,
    speed: 1,
    autoReplay: false,
    replayDuration: 12,
    pause: false
  },
  camera: {
    autoRotate: true,
    autoRotateSpeed: 1,
    orbit: null
  },
  fishEye: {
    enabled: false,
    strength: 0,
    supersampling: '1x',
    radius: 1,
    distortionPower: 2,
    blend: 1,
    chromaticAberration: 0,
    zoom: 1,
    centerX: 0,
    centerY: 0,
    edgeFeather: 0,
    edgeColor: '#ffffff'
  },
  spiral: {
    enabled: true,
    showLine: true,
    startWidth: 1.25,
    middleWidth: 1.45,
    endWidth: 0.9,
    swagSpeed: 0.12,
    swagQuantity: 5,
    swagSize: 0.18,
    swagSmallTargetSize: 0,
    swagCenterSizeBoost: 1.4,
    swagCenterRange: 0.22,
    swagLetterGap: 0.18,
    swagCenterLetterGap: 0.03
  },
  utility: {
    wireframe: false,
    wireframeColor: '#111111',
    wireframeOpacity: 0.45
  },
  gui: {
    folders: {
      Effect: true,
      Camera: true,
      'Fish Eye': true,
      Spiral: true,
      Utility: true
    }
  }
}

export const effectFamilies = {
  Reveal: ['Magic', 'Spread', 'Unroll', 'Twister', 'Rain'],
  Shader: ['Electronic', 'Deep Meditation', 'Waves', 'Disintegrate', 'Flare'],
  Dissolve: ['Dissolve'],
  Transitions: ['Spherical', 'Explosion', 'Flow', 'Morph']
}
